import React from "react";
import CustomerRanking from "../../components/customer/CustomerRanking";
import DonutChart from "../../components/charts/DonurtCharts";
import "./CustomerAnalytics.css";

const CustomersAnalytics: React.FC = () => {
  return (
    <div className="customers__analytics">
      <DonutChart />
      <CustomerRanking />
    </div>
  );
};

export default CustomersAnalytics;
